import React from 'react'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
import PlanTypeCreateModal from 'components/Modals/CreatePlanTypeModal'
// constants
import { Modals } from 'constants/modals'

const CreatePlanTypeButton = () => {
  const { showModal } = useShowModal({ modalType: Modals.PLAN_TYPE_CREATE_MODAL })

  const onButtonClick = () => showModal()

  return (
    <>
      <Button onClick={onButtonClick} style={CREATE_BUTTON_STYLE} layout={BUTTON_LAYOUTS.PURPLE}>
        Create Plan Type
      </Button>
      <PlanTypeCreateModal />
    </>
  )
}

export default CreatePlanTypeButton
